import { Link } from 'react-router-dom';
import { t, tx } from '../../i18n';
import { initials, shorten } from '../../lib/format';
import { usePage } from '../page';
import type { AppContact } from './common/types';
import { appChat, chatPath } from './data';
import { LoadError } from './LoadError';

// Liste „Nachrichten“: ein Eintrag je Ansprechpartner. Bei mehreren Firmen nach Firma gruppiert.
export function ChatList() {
  usePage({
    title: t('Nachrichten'),
    crumbs: [{ label: t('Start'), to: '/app' }, { label: t('Nachrichten') }],
    back: '/app',
    nav: 'nachrichten',
  });
  const data = appChat.useData();
  const error = appChat.useError();
  const firms = data?.firms ?? [];
  const several = firms.length > 1;

  return (
    <>
      <div className="hello">
        <h2>{t('Nachrichten')}</h2>
        <p>{t('Ihre Ansprechpartner in der Kanzlei. Jeder hat einen eigenen Chat.')}</p>
      </div>
      {!data && (error ? <LoadError onRetry={appChat.reload} /> : <div className="spinner" aria-label={t('Lädt')} />)}
      {firms.map((f) => (
        <section key={f.clientId} aria-label={several ? f.clientName : undefined}>
          {several && (
            <div className="sec">
              <h3>{f.clientName}</h3>
            </div>
          )}
          <div className="list">
            {f.contacts.map((c) => (
              <ContactRow key={c.id} c={c} to={chatPath(f.clientId, c.id)} />
            ))}
          </div>
        </section>
      ))}
    </>
  );
}

function ContactRow({ c, to }: { c: AppContact; to: string }) {
  const last = c.last ? (c.last.text ? shorten(c.last.text, 50) : (c.last.fileName ?? '')) : null;
  return (
    <Link to={to} state={{ fromList: true }} className={`item${c.old ? ' chat-old' : ''}`}>
      <span className="ico" aria-hidden="true">
        {initials(c.name)}
      </span>
      <span className="tx">
        <b>{c.name}</b>
        <small>
          {tx(c.role)}
          {c.old ? ` · ${t('nur lesen')}` : ''}
          {last !== null ? ` · „${last}“` : ` · ${t('noch keine Nachrichten')}`}
        </small>
      </span>
      {c.unread > 0 && <span className="badge b-warn">{t('{n} neu', { n: c.unread })}</span>}
      <span className="chev" aria-hidden="true">
        ›
      </span>
    </Link>
  );
}
